import React, { Component } from 'react';

import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';

class DayHeader extends Component {

  constructor(props) {
    super(props);
    this.day = props.day
  }

  render() {
    return (
      <Grid item xs>
        <Typography variant="h6" align="center">{this.day}</Typography>
      </Grid>
    );
  }
}

export default DayHeader;



// WEBPACK FOOTER //
// ./src/comps/DayHeader.js